module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About The Author")]), _vm._v(" "), _c('p', [_vm._v("‘Big Chick’ Huntsberry, who served as Prince’s bodyguard from 1980 to 1985, moved with his family from Tennessee to Chanhassen, MN, in 1984 to work with Prince. Chick started a bodyguard school and a ministry after leaving Prince’s employment.")]), _vm._v(" "), _c('p', [_vm._v("Charles ‘Big Chick’ Huntsberry passed away from heart failure on 2 April 1990.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2486c48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch001.vue
// module id = 63
// module chunks = 0